export default {

  SET_VESSEL_ACTIVITIES: (state, payload) => {
    let entities = payload || [];
    entities.forEach((e, idx) => e.itemIdx = idx);
    state.vesselActivities = entities;
  }
}